'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.init = init;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _themeCart = require('@shopify/theme-cart');

var shopifyCart = _interopRequireWildcard(_themeCart);

var _reactHotLoader = require('react-hot-loader');

var _pushCartActions = require('../store/actions/push-cart-actions');

var pushCartActions = _interopRequireWildcard(_pushCartActions);

var _PushCartContainer = require('../react/containers/PushCartContainer');

var _functional = require('../utils/functional');

var _constants = require('../react/constants');

var _products = require('../services/products');

var _tracking = require('../utils/tracking');

var _baoCart = require('./bao-cart/bao-cart');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function init(_ref) {
  var _this2 = this;

  var el = _ref.el;

  var config = getConfig();
  var action = el.dataset.action;
  var submitTo = el.dataset.submitTo;
  var message = el.dataset.message;

  setupDeliveryConfig();
  setupOpenCartListener();

  function setupDeliveryConfig() {
    var deliveryConfig = {
      firstTier: {
        minimum: parseInt(el.dataset.deliveryFirstTierMinimum, 10),
        maximum: parseInt(el.dataset.deliveryFirstTierMaximum, 10),
        message: el.dataset.deliveryFirstTierMessage
      },
      secondTier: {
        minimum: parseInt(el.dataset.deliverySecondTierMinimum, 10),
        maximum: parseInt(el.dataset.deliverySecondTierMaximum, 10),
        message: el.dataset.deliverySecondTierMessage
      }
    };
    window.store.dispatch(pushCartActions.setDeliveryConfig(deliveryConfig));
  }

  function setupOpenCartListener() {
    var _this = this;

    document.addEventListener('open_cart', function (e) {
      shopifyCart.getState().then(function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(data) {
          var fetchedCompareAtPrices, eventAddToCart;
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _promise2.default.all(data.items.map(function () {
                    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(item) {
                      var _ref4, compare_at_price;

                      return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return (0, _products.getProductByHandleCustomJSON)(item.handle);

                            case 2:
                              _ref4 = _context.sent;
                              compare_at_price = _ref4.compare_at_price;
                              return _context.abrupt('return', {
                                key: item.key,
                                compare_at_price: compare_at_price
                              });

                            case 5:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function (_x2) {
                      return _ref3.apply(this, arguments);
                    };
                  }()));

                case 2:
                  fetchedCompareAtPrices = _context2.sent;
                  eventAddToCart = new Event('view_cart');

                  eventAddToCart.payload = {
                    value: data.total_price / 100,
                    items: data.items.map(function (item) {
                      // eslint-disable-next-line camelcase
                      var _ref5 = fetchedCompareAtPrices.find(function (_ref6) {
                        var key = _ref6.key;
                        return item.key === key;
                      }) || {},
                          compare_at_price = _ref5.compare_at_price;

                      return (0, _tracking.setDataLayerItem)({
                        product: {
                          title: item.title,
                          vendor: item.vendor,
                          product_type: item.product_type
                        },
                        variant: {
                          title: item.variant_title,
                          // eslint-disable-next-line camelcase
                          compare_at_price: String(compare_at_price / 100),
                          price: String(item.final_price / 100),
                          sku: item.sku
                        },
                        quantity: item.quantity
                      });
                    })
                  };
                  document.dispatchEvent(eventAddToCart);

                case 6:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    });
  }

  function getConfig() {
    return JSON.parse((0, _functional.getElement)('#CartConfig').innerHTML);
  }

  shopifyCart.getState().then(function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(data) {
      var itemProperties;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              itemProperties = data.items.map(function (item) {
                return (0, _keys2.default)(item.properties);
              }).flat();

              if (!(itemProperties.includes(_constants.MIX_AND_MATCH_ID_PROPERTY_KEY) && !itemProperties.includes(_constants.MIX_AND_MATCH_CHILD_IS_FIRST_PROPERTY_KEY))) {
                _context3.next = 8;
                break;
              }

              _context3.next = 5;
              return shopifyCart.clearItems();

            case 5:
              _context3.next = 7;
              return shopifyCart.getState();

            case 7:
              data = _context3.sent;

            case 8:
              _context3.next = 13;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](0);

              console.error('Push cart error: ' + _context3.t0);

            case 13:

              window.store.dispatch(pushCartActions.updateLineItems(data));

              render(_PushCartContainer.PushCartContainer);

            case 15:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2, [[0, 10]]);
    }));

    return function (_x3) {
      return _ref7.apply(this, arguments);
    };
  }()).catch(function (err) {
    return console.error('Push cart error: ' + err);
  });

  window.BAOCart = new _baoCart.BAOCart();

  var render = function render(Component) {
    _reactDom2.default.render(_react2.default.createElement(_reactHotLoader.AppContainer, null, _react2.default.createElement(Component, {
      action: action,
      submitTo: submitTo,
      message: message,
      subtitle: config.subtitle,
      cards: config.cards,
      upsellTitle: config.upsellTitle,
      upsellProducts: config.upsellProducts,
      productLimit: config.productLimit,
      useNewPushcartDesign: config.useNewPushcartDesign
    })), el);

    var cartShouldBeOpen = window.location.search.includes('push-cart');

    if (cartShouldBeOpen) {
      window.drawers.activeDrawerKey = 'cart';
    }
  };

  if (module.hot) {
    module.hot.accept('../react/containers/PushCartContainer.js', function () {
      var PushCartContainer = require('../react/containers/PushCartContainer').PushCartContainer;

      render(PushCartContainer);
    });
  }
}